import React, {
  FunctionComponent,
  useContext,
  useEffect,
  useMemo,
  useState,
} from "react";
import JigsawEvent from "../viewer-context/JigsawEvent";
import useJigsawEvent from "../viewer-context/useJigsawEvent";

export enum LoginStatus {
  PENDING,
  LOGGED_IN,
  LOGGED_OUT,
}

type UserContextShape = {
  user?: jigsaw.UserInfo | undefined;
  loginStatus: LoginStatus;
};

const Index = React.createContext<UserContextShape>({
  loginStatus: LoginStatus.PENDING,
});

export const UserProvider: FunctionComponent = ({ children }) => {
  const [user, setUser] = useState<jigsaw.UserInfo | undefined>();
  const [loginStatus, setStatus] = useState(LoginStatus.PENDING);

  useEffect(() => {
    window.Jigsaw.User.getInfo(resp => {
      if (resp.isSuccess()) {
        setUser(resp.data.user);
        setStatus(LoginStatus.LOGGED_IN);
      } else {
        setStatus(LoginStatus.LOGGED_OUT);
      }
    });
  }, []);

  useJigsawEvent(JigsawEvent.USER_SIGNOUT, () => {
    setStatus(LoginStatus.LOGGED_OUT);
    setUser(undefined);
  });

  const value = useMemo(() => {
    return { user, loginStatus };
  }, [user, loginStatus]);

  return <Index.Provider value={value}>{children}</Index.Provider>;
};

// At the point this should be used, we should know we have a user. SessionGate
// will not render children if the user is not logged in.
export function useKnownUser() {
  return useContext(Index).user as jigsaw.UserInfo;
}

export function useLoginStatus() {
  return useContext(Index).loginStatus;
}
